import React, { lazy, Suspense } from 'react';

const LazyAdminBulletinsTable = lazy(() => import('./AdminBulletinsTable'));

const AdminBulletinsTable = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAdminBulletinsTable {...props} />
  </Suspense>
);

export default AdminBulletinsTable;
